export const STATIC_IMAGE_URL = 'https://imgstatic.phonepe.com/images';
export const INSTRUMENTS_IMAGES_SUB_URL =
	'/pfb-web/payment-instruments/256/256';

export const INSTRUMENT_ICONS_MAPPING = {
	UPI_ACCOUNT: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/upi-default.png`,
	UPI: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/upi-default.png`,
	CREDIT_CARD: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/credit-card.png`,
	DEBIT_CARD: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/debit-card.png`,
	FASTAG: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/fastag.png`,
	NCMC: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/ncmc.png`,
	NET_BANKING: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/netbanking.png`,
	CREDIT_LINE_ON_UPI: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/credit-card-on-upi.png`,
	CREDIT_LINE: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/credit-card-on-upi.png`,
	RUPAY_CREDIT_CARD_ON_UPI: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/credit-card-on-upi.png`,
	PHONEPE_WALLET: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/phonepe-wallet.png`,
	PHONEPE_IOCL_WALLET: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/phonepe-wallet.png`,
	PHONEPE_GIFT_CARD: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/phonepe-gift-card.png`,
	EGV: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/phonepe-gift-card.png`,
	WALLET_ON_UPI: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/wallet-default.png`,
	IOCL_WALLET: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/wallet-default.png`,
	IOCLXR: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/wallet-default.png`,
	WALLET: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/wallet-default.png`,
	PHONEPE: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/phonepe.png`,
	AMAZON_PAY: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/amazonpay.png`,
	GPAY: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/gpay.png`,
	PAYTM: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/paytm.png`,
	KOTAK: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/kotak.png`,
	CRED: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/cred.png`,
	WHATSAPP: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/whatsapp.png`,
	HDFC_BANK: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/hdfc-payzapp.png`,
	GOIBIBO: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/goibibo.png`,
	BHIM: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/bhim.png`,
	FAMPAY: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/fampay.png`,
	CC: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/credit-card.png`,
	DC: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/debit-card.png`,
	NETBANKING: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/netbanking.png`,
	OTHERS: `${STATIC_IMAGE_URL}${INSTRUMENTS_IMAGES_SUB_URL}/instrument-default.png`,
};

export const STORES_CONFIG = {
	OFFSET: 0,
	SIZE: 100,
};

export const STORES_KEY_MAPPER = {
	DATA: 'data.stores',
	PAGESIZE: 'size',
	OFFSET: 'offset',
};

export const TRANSACTION_INSTRUMENTS = {
	ACCOUNT: { value: 'ACCOUNT', displayName: 'UPI' },
	WALLET: { value: 'WALLET', displayName: 'Wallet' },
	CREDIT_CARD: { value: 'CREDIT_CARD', displayName: 'Credit Card' },
	DEBIT_CARD: { value: 'DEBIT_CARD', displayName: 'Debit Card' },
	NET_BANKING: { value: 'NET_BANKING', displayName: 'Net Banking' },
	EXTERNAL_WALLET: { value: 'EXTERNAL_WALLET', displayName: 'External Wallet' },
	EGV: { value: 'EGV', displayName: 'EGV' },
	EXTERNAL_VPA: { value: 'EXTERNAL_VPA', displayName: 'External Account' },
	BNPL: { value: 'BNPL', displayName: 'Buy now, Pay later' },
	CREDIT_LINE: { value: 'CREDIT_LINE', displayName: 'Line of Credit' },
};

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Allows `-` and `'` and numbers
export const NAME_REGEX = /^[A-Za-z0-9][A-Za-z0-9\s_'-]*$/

export const OTP_REGEX = /^\d{5}$/;
